/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EPresciptionINFOPRESCRIPTIONPRESCRIPTIONCONTENUPRESCRIPTIONLIGMEDICAMENTEUXInner { 
    CIP?: string;
    CommentairePM?: string;
    Duree?: number;
    EstEnRapportALD?: boolean;
    EstEnRapportAccident?: boolean;
    EstEnRapportPrev?: boolean;
    EstHorsAMM?: boolean;
    EstNonRemb?: boolean;
    EstNonSub?: boolean;
    IDMVN?: string;
    Medicabase?: string;
    Molecules?: string;
    MotifNonSub?: string;
    NbConditionnement?: number;
    NbRenouv?: number;
    NumLigne?: number;
    Posologie?: string;
    RTU?: boolean;
    Specialite?: string;
    TrtAntiBio?: boolean;
    TypeEltPrescrit?: string;
}

